/* c8 ignore start */
import { customerRoutes, mspRoutes } from "./routes";

import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const ReportManagerModule = ({ router, registerNavItems }) => {
  // Routes
  router.addRoute(mspRoutes);
  router.addRoute(customerRoutes);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { ReportManagerModule };

export default {};
/* c8 ignore end */
